<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Classes
              <TotalRegisters :total="classesTableData.total" totalText="classes cadastradas" />
              <Search @doSearch="doSearch" />
            </h4>
            <div class="d-flex align-items-center">
              <button class="btn btn-info btn-sm" @click="visibilityStates.createVisibility = true">Adicionar Classe</button>
            </div>
          </div>

          <Table :tableData="classesTableData" :data="classes" :columns="['id', 'name', 'actions']" :actions="['edit', 'delete']" @pagechanged="onPageChange" @openEditModal="openEditModal()" @openDeleteModal="openDeleteModal()"> </Table>
          <ListLoader v-if="classesTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!classesTableData.loading && classesTableData.error"></Error>
          <Empty v-if="!classesTableData.loading && !classesTableData.error && classes.length === 0"></Empty>
        </card>
      </div>
    </div>

    <Modal v-model="visibilityStates.createVisibility" successMessage="Classe criada com sucesso!" action="Adicionar" title="Adicionar Classe" @closeModal="visibilityStates.createVisibility = false" @confirmAction="create(newClass.name)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" placeholder="Ex: Atendimento do caixa" class="form-control" v-model="newClass.name" @keyup.enter="create(newClass.name)" />
        </div>
      </template>
    </Modal>

    <Modal v-model="visibilityStates.editVisibility" successMessage="Classe atualizada com sucesso!" action="Atualizar" :name="singleClass.name" title="Editar Classe" @closeModal="visibilityStates.editVisibility = false" @confirmAction="update(singleClass.id, singleClass.name)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" hidden class="form-control" v-model="singleClass.id" />
          <input type="text" class="form-control" v-model="singleClass.name" />
        </div>
      </template>
    </Modal>

    <Modal
      v-model="visibilityStates.deleteVisibility"
      successMessage="Classe removida com sucesso!"
      ref="SingleClassTest"
      action="Remover"
      :name="singleClass.name"
      title="Remover Classe"
      @closeModal="visibilityStates.deleteVisibility = false"
      @confirmAction="remove(singleClass.id)"
    >
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" hidden class="form-control" v-model="singleClass.id" />
          <input type="text" class="form-control" v-model="singleClass.name" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Empty from '@/components/Common/Empty';
import Modal from '@/components/Modal/Modal';
import Search from '@/components/Common/Search';
import Table from '@/components/Common/Table';
import TotalRegisters from '@/components/Common/TotalRegisters';

export default {
  components: {
    Empty,
    Modal,
    Search,
    Table,
    TotalRegisters,
  },
  data() {
    return {
      newClass: {
        name: '',
      },
      search: '',
      visibilityStates: {
        createVisibility: false,
        editVisibility: false,
        deleteVisibility: false,
      },
    };
  },
  computed: {
    classes() {
      return this.$store.getters['classes/getClasses'];
    },
    classesTableData() {
      return this.$store.getters['classes/getClassesTableData'];
    },
    singleClass() {
      return this.$store.getters['classes/getClass'];
    },
  },
  methods: {
    openCreateModal: function () {
      this.visibilityStates.createVisibility = true;
    },
    create: async function (name) {
      await this.$store.dispatch('classes/create', { name: name });
      this.visibilityStates.createVisibility = false;
      this.newClass = {};
    },
    openEditModal: async function (id) {
      await this.$store.dispatch('classes/getClassById', id);
      this.visibilityStates.editVisibility = true;
    },
    openDeleteModal: async function (id) {
      await this.$store.dispatch('classes/getClassById', id);
      this.visibilityStates.deleteVisibility = true;
    },
    remove: async function (classId) {
      await this.$store.dispatch('classes/remove', classId);
      this.visibilityStates.deleteVisibility = false;
      this.$store.dispatch('classes/resetPagination');
    },
    update: async function (classId, name) {
      let payload = {
        id: classId,
        params: {
          name: name,
        },
      };
      await this.$store.dispatch('classes/update', payload);
      this.visibilityStates.editVisibility = false;
    },

    onPageChange(page) {
      this.$store.dispatch('classes/setPage', page);
    },
    doSearch: async function (search) {
      this.$store.dispatch('classes/searchClass', search);
    },
  },
  mounted() {
    this.$store.dispatch('classes/resetPagination');
  },
};
</script>
